<template>
    <div>
        <v-toolbar flat fixed color="transparent"
                   id="vorsi-toolbar">
            <v-spacer style="max-width:10%;" class="hidden-sm-and-down"></v-spacer>
            <div @click="changeLocation('/')">
                <icon-base
                    viewBox="0 0 878.885 335"
                    width="150px"
                    style="cursor:pointer"
                >
                    <icon-vorsiToolbarLogo/>
                </icon-base>
            </div>
            <v-spacer></v-spacer>
            <v-toolbar-side-icon
                v-if="mobileLayout === true"
                @click.stop="drawer = !drawer"
                id="primary-toolbar-side-icon"
                class="white--text">
            </v-toolbar-side-icon>
            <div v-if="mobileLayout === false" style="height: 100%">
                <v-btn color="deep-purple" class="top-nav-buttons white--text"
                       @click.native="downloadVorsiDriverPro()"
                >
                    Download Vorsi Driver Pro
                </v-btn>
                <v-btn color="teal darken-2" class="top-nav-buttons white--text"
                       @click.native="downloadVorsiOperatorPro()"
                >
                    Download Vorsi Operator Pro
                </v-btn>
                <v-btn color="info" class="top-nav-buttons white--text"
                       @click.native="changeLocation('/learn-more')">
                    Learn More
                </v-btn>
                <v-btn color="blue darken-2" class="top-nav-buttons white--text"
                       @click.native="changeLocation('/contact-us')">
                    Contact Us
                </v-btn>
                <!--                <v-btn color="info" class="top-nav-buttons white&#45;&#45;text"-->
                <!--                       @click.native="changeLocation('/client/login')"-->
                <!--                       dusk="clientLogin">-->
                <!--                    Client Login-->
                <!--                </v-btn>-->
            </div>
            <!--            <v-spacer style="max-width:5%;" class="hidden-md-and-down"></v-spacer>-->
            <v-dialog v-model="drawer" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-toolbar dark class="nav-gradient">
                    <img src="https://vorsi-home.s3.amazonaws.com/logos/vorsi-white-toolbar.png"
                         style="max-width:150px; cursor:pointer;"
                         @click="changeLocation('/')">
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="drawer = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card>
                    <v-card-text>
                        <v-layout row wrap justify-center align-center class="top-nav-dialog-buttons-container">
                            <v-btn color="deep-purple" class="top-nav-buttons white--text"
                                   @click.native="downloadVorsiDriverPro()"
                            >
                                Download Vorsi Driver Pro
                            </v-btn>
                        </v-layout>
                        <v-layout row wrap justify-center align-center class="top-nav-dialog-buttons-container">
                            <v-btn color="teal darken-2" class="top-nav-buttons white--text"
                                   @click.native="downloadVorsiOperatorPro()"
                            >
                                Download Vorsi Operator Pro
                            </v-btn>
                        </v-layout>
                        <v-layout row wrap justify-center align-center class="top-nav-dialog-buttons-container">
                            <v-btn color="info" class="top-nav-dialog-buttons white--text"
                                   @click.native="changeLocation('/learn-more')">
                                Learn More
                            </v-btn>
                        </v-layout>
                        <v-layout row wrap justify-center align-center class="top-nav-dialog-buttons-container">
                            <v-btn color="blue darken-2" class="top-nav-dialog-buttons white--text"
                                   @click.native="changeLocation('/contact-us')">
                                Contact Us
                            </v-btn>
                        </v-layout>
                        <!--                        <v-layout row wrap justify-center align-center class="top-nav-dialog-buttons-container">-->
                        <!--                            <v-btn color="secondary" class="top-nav-dialog-buttons white&#45;&#45;text"-->
                        <!--                                   @click.native="changeLocation('/user/login')" dusk="userLoginMobile">-->
                        <!--                                User Login-->
                        <!--                            </v-btn>-->
                        <!--                        </v-layout>-->
                        <!--                        <v-layout row wrap justify-center align-center class="top-nav-dialog-buttons-container">-->
                        <!--                            <v-btn color="info" class="top-nav-dialog-buttons white&#45;&#45;text"-->
                        <!--                                   @click.native="changeLocation('/client/login')">-->
                        <!--                                Client Login-->
                        <!--                            </v-btn>-->
                        <!--                        </v-layout>-->
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-toolbar>
    </div>
</template>

<script>
import IconBase from './icons/IconBase.vue';
import IconVorsiToolbarLogo from './icons/IconVorsiToolbarLogo.vue';

export default {
    components: {
        IconBase,
        IconVorsiToolbarLogo,
    },
    data: () => ({
        drawer: false,
        mobileLayout: '',
    }),
    created() {
        setTimeout(() => {
            this.mobileLayout = !(window.innerWidth > 855);
        }, 100);
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', () => {
                this.mobileLayout = !(window.innerWidth > 855);
            });
            window.addEventListener('scroll', () => {
                if (window.scrollY !== 0) {
                    if (document.getElementById('vorsi-toolbar')) {
                        document.getElementById('vorsi-toolbar').classList.add('vorsi-toolbar-solid');
                        document.getElementById('vorsi-toolbar').classList.remove('vorsi-toolbar-transparent');
                    }
                    if (document.getElementById('primary-toolbar-side-icon')) {
                        document.getElementById('primary-toolbar-side-icon').classList.add('black--text');
                        document.getElementById('primary-toolbar-side-icon').classList.remove('white--text');
                    }
                } else {
                    if (document.getElementById('vorsi-toolbar')) {
                        document.getElementById('vorsi-toolbar').classList.add('vorsi-toolbar-transparent');
                        document.getElementById('vorsi-toolbar').classList.remove('vorsi-toolbar-solid');
                    }
                    if (document.getElementById('primary-toolbar-side-icon')) {
                        document.getElementById('primary-toolbar-side-icon').classList.add('white--text');
                        document.getElementById('primary-toolbar-side-icon').classList.remove('black--text');
                    }
                }
            });
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', () => {
            this.mobileLayout = !(window.innerWidth > 855);
        });
    },
    methods: {
        changeLocation(route) {
            window.location = route;
        },
        downloadVorsiDriverPro() {
            axios.get('/vorsi-driver-pro').then(response => {
                window.location = response.data
            })
        },
        downloadVorsiOperatorPro() {
            axios.get('/vorsi-operator-pro').then(response => {
                window.location = response.data
            })
        },
    },
};
</script>

<style scoped>

</style>
